import * as React from "react"

import Hero from "./Hero"
import HomeHero from "./HomeHero"
import FilterBar from "./FilterBar"
import Accordion from "./Accordion"
import VideoEmbed from "./VideoEmbed"
import FeatureCTA from "./FeatureCTA"
import StaticGrid from "./StaticGrid"
import ContentGrid from "./ContentGrid"
import ContentHero from "./ContentHero"
import TextContent from "./TextContent"
import StatistcsRow from "./StatisticsRow"
import ArticleImage from "./ArticleImage"
import FeatureSlider from "./FeatureSlider"
import DynamicSlider from "./DynamicSlider"
import FormCTABanner from "./FormCTABanner"
import BasicCTABanner from "./BasicCTABanner"
import PressSubHeader from "./PressSubHeader"
import CuratorSection from "./CuratorSection"
import SocialMediaEmbed from "./SocialMediaEmbed"
import FeaturedNarrative from "./FeaturedNarrative"
import SoloFeatureCard from "./Cards/SoloFeatureCard"
import NarrativeTextBlock from "./NarrativeTextBlock"
import FeaturedContentHero from "./FeaturedContentHero"
import NarrativeMapSection from "./NarrativeMapSection"
import InnerPostSignupForm from "./InnerPostSignupForm"
import StateInterferenceMap from "./StateInterferenceMap"
import AffiliatesMapSection from "./AffiliatesMapSection"
import StrategicImperativeIcon from "./StrategicImperativeIcon"
import InnerResourceReadingCTA from "./InnerResourceReadingCTA"
import ResourcePageCTA from "./ResourceComponents/ResourcePageCTA"
import InnerUpdateProjectCard from "./Cards/InnerUpdateProjectCard"
import StrategicImperativesGraphic from "./StrategicImperativesGraphic"
import ExtendedReportColumnBlock from "./ResourceComponents/ExtendedReportColumnBlock"

export default function ComponentSelector({ components }) {

  return (
    <>
      {components?.map(component => {
        switch (component?.componentId) {
          case "basic_slider":
            return <DynamicSlider key={component.headline} component={component} />

          case "accordion":
            return <Accordion key={component.headline} component={component} />

          case "narrative_map_section":
            return (
              <NarrativeMapSection
                key={component.headline}
                component={component}
              />
            )

          case "statistic_row":
            return (
              <StatistcsRow key={component.componentId} component={component} />
            )

          case "home_hero":
            return (
              <HomeHero key={component.componentId} component={component} />
            )

          case "feature_slider":
            return (
              <FeatureSlider key={component.headline} component={component} />
            )

          case "filter_bar":
            return <FilterBar key={component.headline} component={component} />

          case "hero_header":
            return <Hero key={component.headline} component={component} />

          case "content_grid":
            return (
              <ContentGrid key={component.componentId} component={component} />
            )

          case "interference_map":
            return (
              <StateInterferenceMap key={component.componentId} component={component} />
            )

          case "narrative_text_block":
            return (
              <NarrativeTextBlock
                key={component.componentId}
                component={component}
              />
            )

          case "feature_cta":
            return <FeatureCTA key={component.headline} component={component} />

          case "affiliates_map_section":
            return <AffiliatesMapSection key={component.componentId} />

          case "form_cta_banner":
            return (
              <FormCTABanner key={component.headline} component={component} />
            )

          case "basic_cta_banner":
            return (
              <BasicCTABanner key={component.headline} component={component} />
            )

          case "strategic_imperative_graphic":
            return (
              <StrategicImperativesGraphic
                key={component.componentId}
                component={component}
              />
            )

          case "text_content":
            return (
              <TextContent key={component.componentId} component={component} />
            )

          case "social_media_embed":
            return (
              <SocialMediaEmbed
                key={component.componentId}
                component={component}
              />
            )

          case "focus_areas_section":
            return (
              <StaticGrid key={component.componentId} component={component} />
            )

          case "article_image":
            return (
              <ArticleImage key={component.componentId} component={component} />
            )

          case "featured_narrative":
            return <FeaturedNarrative key={component.componentId} component={component}/>

          case "strat_imperative_icon":
            return (
              <StrategicImperativeIcon
                key={component.componentId}
                component={component}
              />
            )

          case "inner_post_signup_form":
            return (
              <InnerPostSignupForm
                key={component.componentId}
                component={component}
              />
            )
          case "curator_section":
            return (
              <CuratorSection
                key={component.componentId}
                component={component}
              />
            )
          case "inner_text_project_card":
            return (
              <InnerUpdateProjectCard
                key={component.componentId}
                component={component}
              />
            )
          case "inner_resource_reading_cta":
            return (
              <InnerResourceReadingCTA
                key={component.headline}
                component={component}
              />
            )
          case "feature_card":
            return (
              <SoloFeatureCard
                key={component.headline}
                featureData={component}
              />
            )
          case "video_embed":
            return (
              <VideoEmbed key={component.embedCode} component={component} />
            )
          case "featured_content_hero":
            return (
              <FeaturedContentHero
                key={component.componentId}
                component={component}
              />
            )
          case "resource_page_cta":
            return (
              <ResourcePageCTA key={component.headline} component={component} />
            )
          case "report_two_column_block":
            return (
              <ExtendedReportColumnBlock
                key={component.componentId}
                component={component}
              />
            )
          case "content_hero":
            return (
              <ContentHero
                key={component.componentId}
                component={component}
              />
            )
          case "press_subheader":
            return (
              <PressSubHeader
                key={component.componentId}
                component={component}
              />
            )
          default:
            break
        }
      })}
    </>
  )
}
